/** Returns submission timestamp value of string
 *
 * @returns {string} submission timestamp as YYYY-MM-DDThh:mm:ss
 */
const getSubmissionTimestamp = () => {
	return new Date().toISOString().replace(/.\d+Z$/g, '');
};

export default getSubmissionTimestamp;
